var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.87837 8.74208C4.87837 5.01853 8.06683 2 12 2C15.9332 2 19.1216 5.01853 19.1216 8.74208C19.1216 12.7709 15.109 15.6838 12.6171 16.8915C12.2277 17.0803 11.7723 17.0803 11.3829 16.8915C8.89102 15.6838 4.87837 12.7709 4.87837 8.74208ZM12 11.481C13.5296 11.481 14.7695 10.2925 14.7695 8.82635C14.7695 7.36021 13.5296 6.17166 12 6.17166C10.4704 6.17166 9.23048 7.36021 9.23048 8.82635C9.23048 10.2925 10.4704 11.481 12 11.481Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74277 13.2136L3.59747 13.4016C3.15088 13.4749 2.80722 13.8301 2.75432 14.2731L2.00723 20.5286C1.92171 21.2447 2.60886 21.8128 3.30998 21.6056L6.62078 20.6272C6.81147 20.5709 7.01476 20.5709 7.20546 20.6272L11.7077 21.9577C11.8984 22.0141 12.1016 22.0141 12.2923 21.9577L16.7945 20.6272C16.9852 20.5709 17.1885 20.5709 17.3792 20.6272L20.69 21.6056C21.3911 21.8128 22.0783 21.2447 21.9928 20.5286L21.2457 14.2731C21.1928 13.8301 20.8491 13.4749 20.4025 13.4016L19.2572 13.2136C18.8577 13.8322 18.3988 14.3963 17.9177 14.9023C16.4474 16.4488 14.6577 17.578 13.2908 18.2404C12.4765 18.6351 11.5235 18.6351 10.7092 18.2404C9.3423 17.578 7.5526 16.4488 6.08233 14.9023C5.60119 14.3963 5.14233 13.8322 4.74277 13.2136Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapAlt);
export default __webpack_public_path__ + "static/media/map-alt.cd2f19f1fcd0ee12a9923ed7e8eeeda5.svg";
export { ForwardRef as ReactComponent };